<template>
  <section
    id="sidebar"
    class="slideDown"
  >

    <div
      v-for="(item, index) in categories"
      class="item"
      :key="item.id"
    >
      <div
        class="name"
        @click="toggle(item)"
        :data-new-label="$t('files.category_list.new')"
      >{{item.name}}</div>
      <div
        v-if="item.childs"
        class="subcat lvl-2 slideRight"
      >
        <div
          v-if="item.name == 'RRPP'"
          class="item"
        >
          <div
            class="name"
            @click="external('comunicacion_form')"
          >{{ $t('files.category_list.title') }}</div>
        </div>

        <div
          v-for="(item2, index2) in item.childs"
          class="item"
          :class="{'new': item2.new_resource, 'selected' : item2.selected}"
          :href="item2.url"
          :key="index2"
        >
          <div
            class="name"
            @click="toggle(item2)"
            :data-new-label="$t('files.category_list.new')"
          >{{item2.name}}</div>

          <div
            v-if="item2.visible === true"
            class="subcat lvl-3"
          >
            <div
              v-for="(item3, index3) in item2.childs"
              class="item"
              :class="{'new': item3.new_resource, 'selected': item3.selected}"
              :href="item3.url"
              :key="index3"
            >
              <div
                class="name"
                @click="select(item3)"
                :data-new-label="$t('files.category_list.new')"
              >{{item3.name}}</div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <!-- <div v-if="type==3" class="external" @click="external('comunicacion_form')">Solicitud de apertura</div> -->
    <div
      v-if="type==1 && this.market == 'ES'"
      class="external"
      @click="external('customresource')"
    >{{ $t('files.category_list.personalized') }}
    </div>
  </section>
</template>

<script>

import { mapGetters, mapState } from 'vuex'

export default {
  props: { categories: Object, type: Number },
  data () {
    return {

    }
  },
  methods: {
    toggle (item) {
      // this.$store.commit('files/showCategory', {type: this.type, category: item});
      this.select(item)
    },
    select (item) {
      // this.$store.commit( 'setLoading', true );
      this.$overlay.loading()
      this.$store.commit('files/selectCategory', { type: this.type, category: item })
      var curcategory = this.$store.getters['files/getCurrentCategory']

      var self = this
      this.$store.dispatch('files/loadFiles', { id: curcategory.id }).then(function (data) {
        console.log('FILES: ' + Object.keys(self.$store.getters['files/getCurrentFiles']()).length)
        // if( Object.keys( self.$store.getters[ 'files/getCurrentFiles']() ).length > 0 ){
        var path = ''
        if (self.type == 1) {
          path = 'nacional_category'
        } else if (self.type == 2) {
          path = 'local_category'
        } else if (self.type == 3) {
          path = 'comunicacion_category'
        } else if (self.type == 4) {
          path = 'toolkits_category'
        } else if (self.type == 5) {
          path = 'practices_category'
        }
        self.$router.push({ name: path, params: { category: item.url } })

        self.$store.commit('files/setCurrentFile', false)
        self.$overlay.hide()
        // }
        // else{
        //   self.$overlay.hide();
        // }
      })
    },
    external (component) {
      this.$router.push({ name: component })
    }
  },
  computed: {
    market() {
      return this.$store.getters['getMarket']
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.external {
  cursor: pointer;
}

#sidebar {
  max-width: 350px;
  width: 350px;
  text-align: left;
  padding: 10px;
  width: 100%;
  margin-top: 20px;
  overflow-y: auto;
  position: fixed;
  height: calc(100vh - 120px);

  .item {
    .name {
      background-color: #004412;
      overflow: hidden;
      font-weight: bold;
      padding: 5px;
      color: #fff;
      cursor: pointer;
      text-transform: uppercase;
      margin: 10px 0;
    }
    .subcat {
      &.lvl-2 {
        margin: 25px 0;

        & > .item {
          .name {
            background-color: transparent;
            color: #222222;
            padding: 2px;
            margin: 0;
            text-transform: none;
            padding-left: 25px;
            border-left: 5px solid transparent;
          }

          &.new {
            & > .name {
              &:after {
                content: attr(data-new-label);
                text-align: center;
                display: inline-block;
                width: 60px;
                background: #ffbb0c;
                margin-left: 10px;
                color: #000;
              }
            }
          }

          &.selected {
            & > .name {
              font-family: Speedee-Bold;
              color: #004412;
              border-left: 5px solid #ffbb0c;
            }
          }
        }
      }

      &.lvl-3 {
        margin: 0;

        & > .item {
          .name {
            background-color: transparent;
            color: #222222;
            font-weight: lighter;
            padding-left: 50px;
          }

          &.new {
            .name {
              &:after {
                content: attr(data-new-label);
                display: inline-block;
                color: #ffbb0c;
                border-radius: 100%;
                margin-left: 10px;
                font-size: 8pt;
                background: none;
                font-weight: bold;
              }
            }
          }
          &.selected {
            & > .name {
              font-family: Speedee-Bold;
              color: #004412;
            }
          }
        }
      }
    }
  }
}
</style>
